export default __webpack_public_path__ + "static/tooltip-info-dont-light-db582454450426a883c3f6c6d34c86d2.png";